import { Label, Stack } from "@fluentui/react";
import React from "react";

import { Text } from "../../items/Text";
import { Link } from "../../navigations/Link";

export interface LabeledLinkProps {
    label: string;
    value: string;
    href: string;
    underlineHref?: boolean;
    maxLength?: number;
    testId?: string;
}

export const LabeledLink: React.FunctionComponent<LabeledLinkProps> = (props: LabeledLinkProps) => {
    const hrefStyle = { root: {} };

    if (props.underlineHref) {
        hrefStyle.root["text-decoration"] = "underline";
    }

    return (
        <Stack data-testId={props.testId} styles={{ root: { marginBottom: 10 } }}>
            <Label styles={{ root: { paddingRight: 10 } }}>{props.label}</Label>
            <Link href={`#${props.href}`}>
                <Text maxLength={props.maxLength} value={props.value} styles={hrefStyle} />
            </Link>
        </Stack>
    );
};
